import { CityExperienceReviewRO } from '@routellers/types/dist/city-experience-review/city-experience-review.ro';
import { CreateExperienceReviewDto } from '@routellers/types/dist/city-experience-review/create-experience-review.dto';
import { ExperienceReviewStatusEnum } from '@routellers/types/dist/city-experience-review/enum/experience-review-status.enum';
import { ExperienceReviewSubjectEnum } from '@routellers/types/dist/city-experience-review/enum/experience-review-subject.enum';
import { ModerateExperienceReviewDto } from '@routellers/types/dist/city-experience-review/moderate-experience-review.dto';

import { ApiMethodDeclaration } from '..';

export type ListExperienceReviewsParams = {
    status?: ExperienceReviewStatusEnum;
    cityId?: number;
    subjectType?: ExperienceReviewSubjectEnum;
};

const query: ApiMethodDeclaration<ListExperienceReviewsParams | undefined, CityExperienceReviewRO[]> =
    (params) => ({
        url: '/admin/city-experience-reviews',
        method: 'GET',
        params,
    });

const getOne: ApiMethodDeclaration<number, CityExperienceReviewRO> = (id) => ({
    url: `/admin/city-experience-reviews/${id}`,
    method: 'GET',
});

const create: ApiMethodDeclaration<{ data: CreateExperienceReviewDto }, CityExperienceReviewRO> = ({
    data,
}) => ({
    url: '/admin/city-experience-reviews',
    method: 'POST',
    data,
});

const moderate: ApiMethodDeclaration<
    { id: number; data: ModerateExperienceReviewDto },
    CityExperienceReviewRO
> = ({ id, data }) => ({
    url: `/admin/city-experience-reviews/${id}/moderate`,
    method: 'POST',
    data,
});

const translateAll: ApiMethodDeclaration<number, CityExperienceReviewRO> = (id) => ({
    url: `/admin/city-experience-reviews/${id}/translate-all`,
    method: 'POST',
});

const remove: ApiMethodDeclaration<number, { success: boolean }> = (id) => ({
    url: `/admin/city-experience-reviews/${id}`,
    method: 'DELETE',
});

export const cityExperienceReviewsApiDeclaration = {
    query,
    getOne,
    create,
    moderate,
    translateAll,
    remove,
};
